/* RESPONSIBLE TEAM: team-inbox-management */
import ApplicationAdapter from '../application';

export default class DomainObjectTypeAdapter extends ApplicationAdapter {
  pathForType() {
    return 'domain_object_types';
  }
}
